/* istanbul ignore file */
/**
 * to export your component as an MCP widget you must call mcpDefinition() as the default export
 * @example
 * // my-component.jsx
 * export default mcpDefinition(MyComponent, {
 *   preload: async (props, { store, preloader }) => {},
 *   props: aiParams => normalizeParams(aiParams),
 * });
 */
export function mcpDefinition(Component, config = {}) {
  return {
    Component,
    ...config,
  };
}
